module.exports = __webpack_public_path__ + "img/logo-w.3773743d.png";